import { Page } from '@/core/architecture'

import { ConsolePreSaleDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePreSaleDetail Page
 * Implemented as a practical sample.
 */
export const ConsolePreSaleDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePreSaleDetailTemplate state={state} {...actions} />
}
